const initialState = {
  location: "Location",
  brand: "Brand",
  name: "Full Name",
  position: "Position",
  department: "Position, Department",
  phone: "800.862.8921",
  email: "email@web.com",
  subBrand: null,
  mobileNumber: "800.862.8921",
};

const form = (state = initialState, action) => {
  switch (action.type) {
    case "ON_LOCATION_SELECT":
      return {
        ...state,
        location: action.value
      };
    case "ON_BRAND_SELECT":
      return {
        ...state,
        brand: action.value
      };
    case "ON_NAME_INPUT":
      return {
        ...state,
        name: action.value
      };
    case "ON_POSITION_INPUT":
      return {
        ...state,
        position: action.value
      };
    case "ON_DEPARTMENT_INPUT":
      return {
        ...state,
        department: action.value
      };
    case "ON_PHONE_INPUT":
      return {
        ...state,
        phone: action.value
      };
    case "ON_EMAIL_INPUT":
      return {
        ...state,
        email: action.value
      };
    case "ON_SUB_BRAND_CHOICE":
      return {
        ...state,
        subBrand: action.value
      }
    case "ON_MOBILE_NUMBER_INPUT":
      return {
        ...state,
        mobileNumber: action.value
      };

    default:
      return state;
  }
};

export default form;



// WEBPACK FOOTER //
// ./src/reducers/form.js